import * as OverviewsModule from './v1/overview/index';
import type { GetResponseModel as OverviewGetResponseModel } from './v1/overview/model';

import * as backupsModule from './v1/backups/index';

import * as billingModule from './v1/billing/index';

import * as chargesModule from './v1/charges/index';

import * as dashboardModule from './v1/dashboard/index';

import * as kycModule from './v1/kyc/index';

import * as myDriveModule from './v1/my-drive/index';

import * as quotasModule from './v1/quotas/index';

import * as sshKeysModule from './v1/ssh-keys/index';

import * as instancesModule from './v1/instances/index';

import * as baremetalsModule from './v1/baremetals/index';

import * as securityGroupsModule from './v1/firewalls/security-groups/index';

import * as securityGroupRulesModule from './v1/firewalls/security-group-rules/index';

import * as vmRulesModule from './v1/firewalls/vm-rules/index';

import * as containersModule from './v1/containers/index';

import * as kuferContainersModule from './v1/kufer/containers/index';
import * as kuferBuildsModule from './v1/kufer/builds/index';
import * as kuferDomainMappingsModule from './v1/kufer/domain-mappings/index';
import * as kuferVolumesModule from './v1/kufer/volumes/index';
import * as kuferGithubModule from './v1/kufer/github/index';
import * as kuferRegistryCredentialsModule from './v1/kufer/registry-credentials/index';

import * as sammelnProjectsModule from './v1/sammeln/projects/index';
import * as sammelnRepositoriesModule from './v1/sammeln/repositories/index';
import * as sammelnWebhooksModule from './v1/sammeln/webhooks/index';
import * as sammelnRetentionModule from './v1/sammeln/retention/index';

import * as registryModule from './v1/registry/index';

import * as announcementsModule from './v1/announcements/index';
import type { AnnouncementModel } from './v1/announcements/model';

import * as usersModule from './v1/users/index';
import * as authenticationModule from './v1/authentication/index';
import * as notificationPreferencesModule from './v1/notification-preferences/index';

import * as pricingModule from './v1/pricing/index';
import type { ProductsPricingResponse } from './v1/pricing/model';

import * as maintenanceModule from './v1/maintenance/index';

import * as projectsModule from './v1/projects/index';

import * as blockStorageModule from './v1/block-storage/index';
import type { MaintenanceStatus } from './v1/maintenance/index';

export namespace Endpoints {
    export namespace v1 {
        export namespace Overview {
            export const getDashboard = OverviewsModule.getDashboard;

            export type GetResponseModel = OverviewGetResponseModel;
        }

        export namespace Pricing {
            export const getProductsPricing = pricingModule.getProductsPricing;

            export type ProductsResponseModel = ProductsPricingResponse;
        }

        export namespace Maintenance {
            export const getStatus = maintenanceModule.getMaintenanceStatus;

            export type StatusModel = MaintenanceStatus;
        }

        export namespace Backups {
            export const toggleBackup = backupsModule.toggleBackup;
            export const getBackupSetting = backupsModule.getBackupSetting;
            export const updateBackupSetting = backupsModule.updateBackupSetting;
            export const getAllBackup = backupsModule.getAllBackup;
            export const forceBackup = backupsModule.forceBackup;
            export const restoreBackup = backupsModule.restoreBackup;
            export const deleteBackup = backupsModule.deleteBackup;
        }

        export namespace Billing {
            export const checkUnsetBilling = billingModule.checkUnsetBilling;
            export const getHistoryBill = billingModule.getHistoryBill;
            export const updateBilling = billingModule.updateBilling;
            export const getBilling = billingModule.getBilling;
            export const redeemCoupon = billingModule.redeemCoupon;
            export const getCreditSummary = billingModule.getCreditSummary;
            export const getTrialCreditStatus = billingModule.getTrialCreditStatus;
            export const claimTrialCredit = billingModule.claimTrialCredit;
        }

        export namespace Charges {
            export const createCharge = chargesModule.createCharge;
            export const getChargeInfo = chargesModule.getChargeInfo;
        }

        export namespace Dashboard {
            export const getDashboardStatistics = dashboardModule.getDashboardStatistics;
        }

        export namespace KYC {
            export const confirmKYCLevel1 = kycModule.confirmKYCLevel1;
            export const confirmKYCLevel2 = kycModule.confirmKYCLevel2;
        }

        export namespace MyDrive {
            export const getMyDrive = myDriveModule.getMyDrive;
        }

        export namespace Quotas {
            export const getQuotas = quotasModule.getQuotas;
        }

        export namespace SSHKeys {
            export const getSSHKeys = sshKeysModule.getSSHKeys;
            export const addSSHKey = sshKeysModule.addSSHKey;
            export const deleteSSHKey = sshKeysModule.deleteSSHKey;
        }

        export namespace Instances {
            export const getLaunchOptions = instancesModule.getLaunchOptions;
            export const getCloudComputePackages = instancesModule.getCloudComputePackages;
            export const launchInstance = instancesModule.launchInstance;
            export const getInstanceTags = instancesModule.getInstanceTags;
            export const createInstanceTag = instancesModule.createInstanceTag;
            export const deleteInstanceTag = instancesModule.deleteInstanceTag;
            export const getInstances = instancesModule.getInstances;
            export const getInstance = instancesModule.getInstance;
            export const updateInstance = instancesModule.updateInstance;
            export const invokeAction = instancesModule.invokeAction;
            export const deleteInstance = instancesModule.deleteInstance;
            export const openConsole = instancesModule.openConsole;
            export const getTerminalStatus = instancesModule.getTerminalStatus;
            export const enableTerminal = instancesModule.enableTerminal;
            export const getInstanceActivityLogs = instancesModule.getInstanceActivityLogs;
            export const getInstanceCostSummary = instancesModule.getInstanceCostSummary;
            export const getResizeOptions = instancesModule.getResizeOptions;
            export const resizeInstance = instancesModule.resizeInstance;
            export const reapplyPrivateNetwork = instancesModule.reapplyPrivateNetwork;
        }

        export namespace Baremetals {
            export const getBaremetalLaunchOptions = baremetalsModule.getBaremetalLaunchOptions;
            export const getAvailableBaremetalNodes = baremetalsModule.getAvailableBaremetalNodes;
            export const launchBaremetal = baremetalsModule.launchBaremetal;
            export const getBaremetals = baremetalsModule.getBaremetals;
            export const getBaremetal = baremetalsModule.getBaremetal;
            export const permuteAutoRenew = baremetalsModule.permuteAutoRenew;
            export const changePaymentPeriod = baremetalsModule.changePaymentPeriod;
            export const sendCommand = baremetalsModule.sendCommand;
            export const deleteBaremetal = baremetalsModule.deleteBaremetal;
        }

        export namespace Firewalls {
            export namespace SecurityGroups {
                export const listSecurityGroups = securityGroupsModule.listSecurityGroups;
                export const createSecurityGroup = securityGroupsModule.createSecurityGroup;
                export const batchDeleteSecurityGroups =
                    securityGroupsModule.batchDeleteSecurityGroups;
                export const updateSecurityGroup = securityGroupsModule.updateSecurityGroup;
                export const deleteSecurityGroup = securityGroupsModule.deleteSecurityGroup;
            }

            export namespace SecurityGroupRules {
                export const listRules = securityGroupRulesModule.listRules;
                export const createRule = securityGroupRulesModule.createRule;
                export const batchDeleteRules = securityGroupRulesModule.batchDeleteRules;
                export const updateRule = securityGroupRulesModule.updateRule;
                export const deleteRule = securityGroupRulesModule.deleteRule;
                export const moveRulePosition = securityGroupRulesModule.moveRulePosition;
            }

            export namespace VMRules {
                export const listRules = vmRulesModule.listRules;
                export const createRule = vmRulesModule.createRule;
                export const updateRule = vmRulesModule.updateRule;
                export const deleteRule = vmRulesModule.deleteRule;
                export const deleteSecurityGroupRules = vmRulesModule.deleteSecurityGroupRules;
                export const batchDeleteRules = vmRulesModule.batchDeleteRules;
                export const moveRulePosition = vmRulesModule.moveRulePosition;
            }
        }

        export namespace Containers {
            export const getPrerequisite = containersModule.getPrerequisite;
            export const activate = containersModule.activate;
            export const getContainerQuota = containersModule.getContainerQuota;
            export const getContainerCost = containersModule.getContainerCost;
        }

        export namespace BlockStorage {
            export const listVolumes = blockStorageModule.listVolumes;
            export const getVolume = blockStorageModule.getVolume;
            export const createVolume = blockStorageModule.createVolume;
            export const updateVolume = blockStorageModule.updateVolume;
            export const deleteVolume = blockStorageModule.deleteVolume;
            export const attachVolume = blockStorageModule.attachVolume;
            export const detachVolume = blockStorageModule.detachVolume;
        }

        export namespace Kufer {
            export namespace Containers {
                export const listContainers = kuferContainersModule.listContainers;
                export const createContainer = kuferContainersModule.createContainer;
                export const getContainer = kuferContainersModule.getContainer;
                export const getContainerStatus = kuferContainersModule.getContainerStatus;
                export const updateContainer = kuferContainersModule.updateContainer;
                export const deleteContainer = kuferContainersModule.deleteContainer;
                export const restartContainer = kuferContainersModule.restartContainer;
                export const redeployContainer = kuferContainersModule.redeployContainer;
                export const getContainerLogs = kuferContainersModule.getContainerLogs;
                export const requestContainerLogTicket =
                    kuferContainersModule.requestContainerLogTicket;
                export const getContainerMetrics = kuferContainersModule.getContainerMetrics;
                export const getContainerDeletionTimestamp =
                    kuferContainersModule.getContainerDeletionTimestamp;
            }

            export namespace Builds {
                export const listBuilds = kuferBuildsModule.listBuilds;
                export const getBuild = kuferBuildsModule.getBuild;
                export const getBuildLogs = kuferBuildsModule.getBuildLogs;
                export const getLatestBuildLogs = kuferBuildsModule.getLatestBuildLogs;
                export const requestBuildLogTicket = kuferBuildsModule.requestBuildLogTicket;
                export const cancelBuild = kuferBuildsModule.cancelBuild;
                export const rebuildContainer = kuferBuildsModule.rebuildContainer;
            }

            export namespace DomainMappings {
                export const listDomainMappings = kuferDomainMappingsModule.listDomainMappings;
                export const getDomainMapping = kuferDomainMappingsModule.getDomainMapping;
                export const createDomainMapping = kuferDomainMappingsModule.createDomainMapping;
                export const deleteDomainMapping = kuferDomainMappingsModule.deleteDomainMapping;
            }

            export namespace Volumes {
                export const listVolumes = kuferVolumesModule.listVolumes;
                export const getVolume = kuferVolumesModule.getVolume;
                export const createVolume = kuferVolumesModule.createVolume;
                export const resizeVolume = kuferVolumesModule.resizeVolume;
                export const deleteVolume = kuferVolumesModule.deleteVolume;
            }

            export namespace GitHub {
                export const getAuthorizeUrl = kuferGithubModule.getAuthorizeUrl;
                export const completeCallback = kuferGithubModule.completeCallback;
                export const getAuthorization = kuferGithubModule.getAuthorization;
                export const deleteAuthorization = kuferGithubModule.deleteAuthorization;
                export const listRepositories = kuferGithubModule.listRepositories;
                export const getDockerfile = kuferGithubModule.getDockerfile;
            }

            export namespace RegistryCredentials {
                export const listCredentials = kuferRegistryCredentialsModule.listCredentials;
                export const getCredential = kuferRegistryCredentialsModule.getCredential;
                export const createCredential = kuferRegistryCredentialsModule.createCredential;
                export const updateCredential = kuferRegistryCredentialsModule.updateCredential;
                export const deleteCredential = kuferRegistryCredentialsModule.deleteCredential;
            }
        }

        export namespace Sammeln {
            export namespace Projects {
                export const listProjects = sammelnProjectsModule.listProjects;
                export const getProject = sammelnProjectsModule.getProject;
                export const createProject = sammelnProjectsModule.createProject;
                export const deleteProject = sammelnProjectsModule.deleteProject;
            }

            export namespace Repositories {
                export const listRepositories = sammelnRepositoriesModule.listRepositories;
                export const getRepository = sammelnRepositoriesModule.getRepository;
                export const deleteRepository = sammelnRepositoriesModule.deleteRepository;
            }

            export namespace Webhooks {
                export const listWebhooks = sammelnWebhooksModule.listWebhooks;
                export const getWebhook = sammelnWebhooksModule.getWebhook;
                export const getSupportedEventTypes = sammelnWebhooksModule.getSupportedEventTypes;
                export const createWebhook = sammelnWebhooksModule.createWebhook;
                export const updateWebhook = sammelnWebhooksModule.updateWebhook;
                export const deleteWebhook = sammelnWebhooksModule.deleteWebhook;
            }

            export namespace Retention {
                export const listRetentionPolicies = sammelnRetentionModule.listRetentionPolicies;
                export const getRetentionPolicy = sammelnRetentionModule.getRetentionPolicy;
                export const createRetentionPolicy = sammelnRetentionModule.createRetentionPolicy;
                export const updateRetentionPolicy = sammelnRetentionModule.updateRetentionPolicy;
                export const deleteRetentionPolicy = sammelnRetentionModule.deleteRetentionPolicy;
            }
        }

        export namespace Projects {
            export const listProjects = projectsModule.listProjects;
            export const createProject = projectsModule.createProject;
            export const getProject = projectsModule.getProject;
            export const updateProject = projectsModule.updateProject;
            export const deleteProject = projectsModule.deleteProject;
            export const leaveProject = projectsModule.leaveProject;
            export const listActivity = projectsModule.listActivity;
            export const listMembers = projectsModule.listMembers;
            export const updateMember = projectsModule.updateMember;
            export const removeMember = projectsModule.removeMember;
            export const createInvitation = projectsModule.createInvitation;
            export const listInvitations = projectsModule.listInvitations;
            export const revokeInvitation = projectsModule.revokeInvitation;
            export const listProjectRequests = projectsModule.listProjectRequests;
            export const acceptInvitation = projectsModule.acceptInvitation;
            export const declineInvitation = projectsModule.declineInvitation;
            export const setPayer = projectsModule.setPayer;
            export const acceptPayer = projectsModule.acceptPayer;
            export const declinePayer = projectsModule.declinePayer;
            export const offerTransfer = projectsModule.offerTransfer;
            export const cancelTransfer = projectsModule.cancelTransfer;
            export const acceptTransfer = projectsModule.acceptTransfer;
            export const declineTransfer = projectsModule.declineTransfer;
            export const listResources = projectsModule.listResources;
            export const moveResources = projectsModule.moveResources;
        }

        export namespace Registry {
            export const resetPassword = registryModule.resetPassword;
        }

        export namespace Announcements {
            export const listAnnouncements = announcementsModule.listAnnouncements;
            export type Model = AnnouncementModel;
        }

        export namespace Users {
            export const getMe = usersModule.getMe;
            export const updateMe = usersModule.updateMe;
            export const sendChangePhone = usersModule.sendChangePhone;
            export const verifyChangePhone = usersModule.verifyChangePhone;
        }

        export namespace Authentication {
            export const getUserInfo = authenticationModule.getUserInfo;
            export const requestChangePassword = authenticationModule.requestChangePassword;
            export const changePassword = authenticationModule.changePassword;
            export const sendEmailVerification = authenticationModule.sendEmailVerification;
            export const verifyEmail = authenticationModule.verifyEmail;
            export const requestResetEmail = authenticationModule.requestResetEmail;
            export const resetEmail = authenticationModule.resetEmail;
            export const sendPhoneVerification = authenticationModule.sendPhoneVerification;
            export const verifyPhone = authenticationModule.verifyPhone;
            export const toggle2FA = authenticationModule.toggle2FA;
            export const signIn = authenticationModule.signIn;
            export const signUp = authenticationModule.signUp;
            export const requestResetPassword = authenticationModule.requestResetPassword;
            export const confirmResetPassword = authenticationModule.confirmResetPassword;
            export const verify2FA = authenticationModule.verify2FA;
            export const send2FACode = authenticationModule.send2FACode;
            export const getGithubAuthorizeUrl = authenticationModule.getGithubAuthorizeUrl;
            export const githubCallback = authenticationModule.githubCallback;
            export const githubLink = authenticationModule.githubLink;
            export const githubUnlink = authenticationModule.githubUnlink;
            export const oauthLinkVerify = authenticationModule.oauthLinkVerify;
        }

        export namespace NotificationPreferences {
            export const getNotificationPreferences =
                notificationPreferencesModule.getNotificationPreferences;
            export const updateNotificationPreferences =
                notificationPreferencesModule.updateNotificationPreferences;
        }
    }
}
